import React, { useEffect } from "react";
import { indexStore } from "../store/indexStore";
type TabsProps = {
  data: any;
  value: any;
  onChange: any;
};
const Tabs = (props: TabsProps) => {
  useEffect(() => {
    if (props.data.length !== 0) {
      const activeElement = document.querySelector(".cat-active");

      if (activeElement) {
        activeElement.scrollIntoView({
          behavior: "smooth",
          inline: "center",
          block: "nearest",
        });
      }
    }
  }, [props.onChange, props.data]);
  return (
    <div className="flex gap-2 md:gap-3 pb-2 flex-nowrap overflow-x-auto scrollbar-hide py-1">
      {props.data &&
        props.onChange &&
        props.data.map((t: any, i: number) => (
          <div
            key={t.id || i}
            className="opacity-0 animate-[fadeIn_0.3s_ease-out_forwards]"
            style={{
              animationDelay: `${i * 50}ms`,
            }}
          >
            <Tab
              data={t}
              onClick={() => props.onChange(i, t.id)}
              active={t.id === props.value}
            />
          </div>
        ))}
    </div>
  );
};

const Tab = (props: any) => {
  const { name } = indexStore();
  return (
    <div
      className={`px-4 py-2.5 md:px-5 md:py-3 rounded-lg cursor-pointer transition-all duration-300 text-sm md:text-base font-semibold flex items-center whitespace-nowrap ${
        props.active
          ? "bg-primary text-onPrimary shadow-lg shadow-primary/20 cat-active scale-105"
          : "bg-background text-onBackground shadow-md hover:shadow-lg hover:scale-105 border border-border/50 hover:border-primary/30"
      }`}
      onClick={props.onClick}
    >
      {props.data[name]}
    </div>
  );
};

export default Tabs;
